/* import __COLOCATED_TEMPLATE__ from './office-hours-schedule-editor.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* RESPONSIBLE TEAM: team-frontend-tech */
import { task } from 'ember-concurrency-decorators';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let OfficeHoursScheduleEditor = (_dec = task({
  drop: true
}), (_class = class OfficeHoursScheduleEditor extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "officeHoursSchedules", _descriptor2, this);
    this.fetchOfficeHoursSchedules.perform();
  }
  get scheduleItems() {
    return this.officeHoursSchedules.map(schedule => ({
      text: schedule.name,
      value: schedule.id
    }));
  }
  get selectedScheduleLabel() {
    let schedule = this.officeHoursSchedules.find(schedule => schedule.id === this.args.predicate.value);
    if (schedule) {
      return schedule.labelWithTimezone;
    }
  }
  *fetchOfficeHoursSchedules() {
    try {
      let officeHoursSchedules = yield this.store.findAll('office-hours-schedule');
      this.officeHoursSchedules = officeHoursSchedules.toArray();
      this._maybeSetDefaultOfficeHoursSchedule(officeHoursSchedules);
    } catch (e) {
      this.officeHoursSchedules = [];
    }
  }
  _maybeSetDefaultOfficeHoursSchedule(officeHoursSchedules) {
    if (!this.args.predicate.value) {
      this.args.changePredicateValue(officeHoursSchedules.firstObject.id);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "officeHoursSchedules", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "fetchOfficeHoursSchedules", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "fetchOfficeHoursSchedules"), _class.prototype)), _class));
export { OfficeHoursScheduleEditor as default };